import React, { useState, useEffect, createContext, useContext } from 'react';
import { apiPath } from '../../lib/isTest';
import { isHauptadmin } from '../../lib/globalData';
import dataProvider from '../../lib/dataProvider';
import { List, Create, Edit, Datagrid, SimpleForm, TextField, SelectField, ReferenceInput, BooleanInput, Button, 
  EditButton, TextInput, SelectInput, useRecordContext } from 'react-admin';
import { getInfoValue, CheckRecht } from '../../lib/globalData';
import BulkActionButtons from '../../lib/BulkActionButtons';
import CloseToolbar from '../../lib/CloseToolbar';
import NoPagination from '../../lib/NoPagination';
import MultiInput from '../../lib/rep/MultiInput';
import MailIcon from '@mui/icons-material/MailOutline';
import { useFormContext, useWatch } from "react-hook-form"

const zeitChoices = [
  { id: -1, name: 'link'  },
  { id:  0, name: '00:10' },
  { id:  1, name: '01:10' },
  { id:  2, name: '02:10' },
  { id:  3, name: '03:10' },
  { id:  4, name: '04:10' },
  { id:  5, name: '05:10' },
  { id:  6, name: '06:10' },
  { id:  7, name: '07:10' },
  { id:  8, name: '08:10' },
  { id:  9, name: '09:10' },
  { id: 10, name: '10:10' },
  { id: 11, name: '11:10' },
  { id: 12, name: '12:10' },
  { id: 13, name: '13:10' },
  { id: 14, name: '14:10' },
  { id: 15, name: '15:10' },
  { id: 16, name: '16:10' },
  { id: 17, name: '17:10' },
  { id: 18, name: '18:10' },
  { id: 19, name: '19:10' },
  { id: 20, name: '20:10' },
  { id: 21, name: '21:10' },
  { id: 22, name: '22:10' },
  { id: 23, name: '23:10' },
]

const artChoices = [
  { id: 99, name: 'bw.rep.autorep.flex' },
  { id: 1, name: 'bw.rep.autorep.monatlich_last' },
  { id: 5, name: 'bw.rep.autorep.monatlich_last_p10' },
  { id: 2, name: 'bw.rep.autorep.monatlich_cur' },
  { id: 3, name: 'bw.rep.autorep.monatlich_next' },
  { id: 4, name: 'bw.rep.autorep.monatlich_p12' },
  { id: 11, name: 'bw.rep.autorep.woechentlich_MoSu' },
  { id: 12, name: 'bw.rep.autorep.woechentlich_Hp12M' },
  { id: 21, name: 'bw.rep.autorep.taeglich_YY' },
  { id: 22, name: 'bw.rep.autorep.taeglich_YT' },
  { id: 23, name: 'bw.rep.autorep.taeglich_TT' },
  { id: 25, name: 'bw.rep.autorep.taeglich_TM' },
  { id: 26, name: 'bw.rep.autorep.taeglich_MM' },
  { id: 24, name: 'bw.rep.autorep.taeglich_p30' },
  { id: 27, name: 'bw.rep.autorep.taeglich_1p12M' },
  { id: 28, name: 'bw.rep.autorep.taeglich_Mp3d' },
  { id: 29, name: 'bw.rep.autorep.taeglich_Hp3d' },
  { id: 30, name: 'bw.rep.autorep.taeglich_Hp12M' },
]

const langChoices = [
  { id: 'de', name: 'Deutsch' },
  { id: 'en', name: 'English' },
  { id: 'fr', name: 'Français' },
]

const formatChoices = [
  { id: 'pdf', name: 'PDF' },
  { id: 'excel', name: 'Excel' },
  { id: 'csv', name: 'Text csv' },
]

const ParamContext = createContext();

const ParamProvider = ({ children }) => {
  const [params, setParams] = useState([]);
  const [data, setData] = useState({id_lang: getInfoValue('id_sprache'), id_report: 0, params: [], reports: []});

  return (
    <ParamContext.Provider value={{ params, setParams, data, setData }}>
      {children}
    </ParamContext.Provider>
  );
};

const TestButton = ({ title, filterid, ...rest }) => {
  const record = useRecordContext();
  
  if(!record)return null
  const handleTest = () => {
    dataProvider.getOne('repAutorep/test', { id: record.id})
      .then(response => {
      });
  }
  return (
    <Button variant="text" size="small" label={title} title={title} onClick={handleTest} >
      <MailIcon />
    </Button>
  )
};

const EmailField = () => {
  const record = useRecordContext();
  if(!record)return null
  if(record.zeit === -1){
    if(record.email === '')return null
    return <a href={apiPath+'v1/repLink/'+record.email} target="_blank" rel="noreferrer">Link</a>
  }
  return <TextField source="email" />
}

const ListForm = (props) => {
  return (
    <List title="bw.set.prefcountry.title" sort={{ field: 'art', order: 'ASC' }} 
      exporter={isHauptadmin() && props.exporter} pagination={<NoPagination />} perPage={1000} >
      <Datagrid style={{ width: 'auto' }} bulkActionButtons={<BulkActionButtons />} >
        <SelectField source="art" choices={artChoices} />
        <SelectField source="zeit" choices={zeitChoices} />
        <TextField source="sprache" />
        <TextField source="type" />
        <TextField source="format" />
        <EmailField />
        <TextField source="lastdatum" />
        {isHauptadmin() &&
          <TextField source="id" textAlign="right" />
        }
        <EditButton label="" />
        <TestButton title='test' {...props} />
      </Datagrid>
    </List>
  )
}

const ReportValueInput = ({ defaultValue = [], source='param', ...props }) => {
  const { data, setData } = useContext(ParamContext)
  const { setValue, formState } = useFormContext()
  const id_report = useWatch({ name: 'id_report' })

  useEffect(() => {
    if(id_report && typeof formState.defaultValues !== 'undefined'){
      dataProvider.update('repReport', {id:0, data: {...data, ...{id_report: id_report}} })
      .then(res  => {
        console.log([id_report, formState.defaultValues])
        if(id_report === formState.defaultValues.id_report){
          res.data.params.values = formState.defaultValues.param
          setData(res.data)
        }
        else {
          setData(res.data)
        }
      })
    }
    // eslint-disable-next-line
  }, [id_report, formState.defaultValues]);
  //console.log([source, data.params.values, formState])

  const updateData = (data) => {
    if(data){
      console.log(['130', data, source])
      setData(data)
      if(data.params){
        setValue(source, {...data.params.values}) // bei deep changes wird dirty nicht gesetzt.
        setValue("dummy", "hallo", { shouldDirty: true }) // deshalb setzten wir es bei dummy
      }
    }
  }

  return (
    <div style={{ marginTop: '1em', width: '100%', marginBottom: '2em' }}>
      { data.params.fields && data.params.fields.map((el) =><MultiInput key={el.name} source={el.name} updateData={updateData} ParamContext={ParamContext} />)}
    </div>
  )
}

const EmailInput = () => {
  const rec = useRecordContext()
  const zeit = useWatch({ name: 'zeit' })
  if(zeit === -1){
    if(rec?.email === '')return 
    return <div style={{margin: '2em 0'}}><a href={apiPath+'v1/repLink/'+rec?.email} target="_blank" rel="noreferrer">Link</a></div>
  }
  return <TextInput source="email" />
}

const DateInput = () => {
  const { data, setData } = useContext(ParamContext)
  const art = useWatch({ name: 'art' })

  const updateParamValue = (key, value) => {
    const p = {...data.params}
    p.values[key] = value
    setData({...data, params: p })
  }

  if(!art || art !== 99)return
  return (
    <>
      <TextInput source="param.flexStartDatum" label="Start Datum" onChange={(ev)=>updateParamValue('flexStartDatum', ev.target.value)} disabled={!isHauptadmin()} />
      { data?.showEndDate === true && <TextInput source="param.flexEndDatum" label="End Datum" onChange={(ev)=>updateParamValue('flexEndDatum', ev.target.value)} disabled={!isHauptadmin()} /> }
    </>
  )
}

const CEForm = ({classes, hasList, hasEdit, hasCreate, hasShow, ...props}) => {
  const { setParams } = useContext(ParamContext)
  const rec = useRecordContext()
  useEffect(() => {
    setParams([])
    // eslint-disable-next-line
  }, []);
  const aChoices = [...artChoices]
  if(!isHauptadmin() && rec?.art!==99)aChoices.shift()
  const zChoices = [...zeitChoices]
  if(!isHauptadmin() && rec?.zeit!==-1)zChoices.shift()
  return (
    <SimpleForm toolbar={<CloseToolbar />} {...props}> 
      <SelectInput source="art" choices={aChoices} emptyText='bw.rep.autorep.choose' emptyValue={0} sx={{ minWidth: '15em' }} disabled={!isHauptadmin() && rec?.art===99} />
      <SelectInput source="zeit" choices={zChoices} emptyValue={0} sx={{ minWidth: '15em' }} disabled={!isHauptadmin() && rec?.zeit===-1} />
      <SelectInput source="sprache" choices={langChoices} emptyValue='de' sx={{ minWidth: '15em' }} />
      <ReferenceInput source="id_report" reference="repReport" perPage={999} >
        <SelectInput optionText='bez' />
      </ReferenceInput>
      <ReportValueInput />
      <DateInput />
      <SelectInput source="format" choices={formatChoices} emptyValue='pdf' sx={{ minWidth: '15em' }} />
      <EmailInput />
      <CheckRecht route="repAutorep" level={5} >
        <BooleanInput source="reset" label="Reset Lastdatum"/>
        <TextInput source="lastdatum" disabled />
      </CheckRecht>
    </SimpleForm>
  )
};

const Autorep = {
  list: ({ classes, ...props }) => (
    <ListForm {...props} classes={classes} />
  ),
  
  create: ({classes, ...props }) => (
    <Create {...props} title="bw.set.prefcountry.titleCreate" redirect="list">
      <ParamProvider>
        <CEForm {...props} classes={classes} />
      </ParamProvider> 
    </Create>
  ),
  
  edit: ({ classes, ...props }) => (
    <Edit title="bw.set.prefcountry.titleEdit" mutationMode="pessimistic" {...props}>
      <ParamProvider>
        <CEForm {...props} classes={classes} />
      </ParamProvider> 
    </Edit>
  )
}   
export default Autorep